import { observer } from 'mobx-react';
import { useStore } from '../../../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button, Card, Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../../../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { TextField } from '@mui/material';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
// import Grid from "@mui/material/Grid/Grid";
import Etherimage from "../../../Main/image/2089411.png";
import Dimage from "../../../Main/image/Icon256.png";
// import { useEffect } from "react";
// import UserImage from "../Main/image/User.png";
// import EtherImage from "../Main/image/2089411.png"
// import StandImage from "../Main/image/Icon256.png"
// import { faSquarePlus } from '@fortawesome/free-solid-svg-icons';
// import { faSquareMinus } from '@fortawesome/free-solid-svg-icons';
import { toJS } from 'mobx';
import Slider from 'react-slick';
// import "../../../../../node_modules/slick-carousel/slick/slick.css"
// import "../../../../../node_modules/slick-carousel/slick/slick-theme.css"
import styled from "@emotion/styled";
import JsBarcode from "jsbarcode";
import { useEffect, useState } from "react";
import CouponitemCard from './CouponitemCard';










function MarketCouponitem() {
  const { loginStore } = useStore();
  const { SaleStore } = useStore();
  // const { CoinStore } = useStore();

  const [imageUrl, setImageUrl] = useState('');

  // const navigate = useNavigate();

  const useStyles = makeStyles((theme) => ({
    //Dialog
    Dialog: {
      width: '22rem',
      height: "37rem",
      minHeight: "37rem",
      // minHeight: "auto",
      // backgroundColor:"#212121"

    },
    DialogMobile: {
      height: '100%',
      width: '100%',
      minWidth: "320px",
      padding: '0'
    },
    //CategoryImage
    CategoryImage: {
      whiteSpace: "nowrap",
      objectFit: "cover",
      width: '10rem',
      height: "5rem"
    },
    //CategoryImage
    BrandImage: {
      whiteSpace: "nowrap",
      objectFit: "cover",
      width: '12rem',
      height: "12rem"
    },
    //BrandiamgeSlide
    BrandiamgeSlide: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    },
    DimagePC: {
      width: '2rem',
      height: "2rem"
    },
    DimageMobile: {
      width: '40%',
      height: "40%"
    },
    EtherimagePC: {
      width: '2rem',
      height: "2rem"
    },
    EtherimageMobile: {
      width: '40%',
      height: "40%"
    }
  }));


  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");




  const WhiteTextTypography = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '1rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1rem',
      }
  })(Typography);

  const CategoryTypography = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '1.5rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1.2rem',
      }
  })(Typography);


  const BrandTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.8rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1.5rem',
      }
  })(Typography);

  const MobileTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '1.5rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1rem',
      }
  })(Typography);

  const PCTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.8rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1.5rem',
      }
  })(Typography);



  const isCloverMarketCouponitemDialogOpen = loginStore?.isCloverMarketCouponitemDialogOpen;
  // let isUserMarketPage = SaleStore?.isUserMarketPage;

  let memberCouponData = toJS(SaleStore?.member_coupon_data);

  // console.log("D data", memberCouponData);





  let epin = String(memberCouponData?.member_epin);
  // let epin = String(12345678123);


  useEffect(() => {// 바코드 이미지 생성
    if (epin !== undefined && epin !== null && epin !== "") {
      const canvas = document.createElement('canvas')
      JsBarcode(canvas, epin, { height: 50, displayValue: true, format: "CODE128", fontSize: 15 })
      setImageUrl(canvas.toDataURL('image/png'))
    }
  }, [epin]);




  return (
    <div style={{ padding: 0, margin: 0 }}>
      <Dialog fullScreen={isMobile ? true : false} classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isCloverMarketCouponitemDialogOpen} onClose={loginStore.setDialogClose()}>
        <Box sx={isMobile ? { bgcolor: "#212121", width: "100%", height: "100%" } : { bgcolor: "#212121", width: "80rem", height: "80rem" }}>
          <Box sx={isMobile ?
            { display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600px', minWidth: '320px', height: '60px', }
            :
            { display: 'flex', bgcolor: 'black', width: '22rem', height: '50px', }}>
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' >
              <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="center"  >
                <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
                <WhiteTextTypography >
                  {memberCouponData?.goods_name}
                  {/* 함께해요( 아메리카노( R ) 2잔) */}
                </WhiteTextTypography>
              </Grid>
              <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
                <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("CloverMarketCouponitemFalse") }} />
              </Grid>
            </Grid>
          </Box>


          <DialogContent sx={{ padding: 0, margin: 0 }} >
            <CouponitemCard key={memberCouponData.Index} item={memberCouponData} />

          </DialogContent>
          :





        </Box>
      </Dialog>
    </div>
  );
};

export default observer(MarketCouponitem);


